import { render, staticRenderFns } from "./authorizedArrears.vue?vue&type=template&id=2f632d10&scoped=true&"
import script from "./authorizedArrears.vue?vue&type=script&lang=js&"
export * from "./authorizedArrears.vue?vue&type=script&lang=js&"
import style0 from "./authorizedArrears.vue?vue&type=style&index=0&id=2f632d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f632d10",
  null
  
)

export default component.exports